import { Suspense } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet } from 'react-router-dom';

import { Contents, SideBar } from './components';
import AllScreenSpinner from './components/AllScreenSpinner';
import { GlobalErrorFallback } from './components/ErrorFallback/GlobalErrorFallback';
import useTokenValidator from './hooks/useTokenValidator';
import { PathNames } from './types/client/url';
import cookieHelper from './utils/cookieHelper';
import { UrlUtil } from './utils/url';

const PrivateRoute = (): JSX.Element => {
  useTokenValidator();

  if (cookieHelper.hasAccessToken()) {
    return (
      <ErrorBoundary FallbackComponent={GlobalErrorFallback}>
        <SideBar />
        <Suspense fallback={<AllScreenSpinner />}>
          <Contents>
            <Outlet />
          </Contents>
        </Suspense>
      </ErrorBoundary>
    );
  }

  return <Navigate to={UrlUtil.getUrl(PathNames.LOGIN)} />;
};

export default PrivateRoute;
